"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_router_1 = require("react-router");
var components_1 = require("stremio/components");
var useServiceWorkerUpdater_1 = __importDefault(require("./useServiceWorkerUpdater"));
var WebUpdateScreen_less_1 = __importDefault(require("./WebUpdateScreen.less"));
var WebUpdateScreen = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = (0, useServiceWorkerUpdater_1.default)(), state = _a.state, dismissed = _a.dismissed, applyUpdate = _a.applyUpdate, dismissUpdate = _a.dismissUpdate;
    var isPlayer = (0, react_router_1.useMatch)('/player/*');
    var autoApply = state.status === 'ready' && state.autoApply;
    var promptVisible = !dismissed &&
        isPlayer === null &&
        (state.status === 'ready' || state.status === 'reload-ready' || state.status === 'failed');
    (0, react_1.useEffect)(function () {
        if (autoApply && isPlayer === null) {
            applyUpdate();
        }
    }, [applyUpdate, autoApply, isPlayer]);
    if (state.status === 'applying') {
        return (react_1.default.createElement("div", { className: WebUpdateScreen_less_1.default['web-update-screen'], role: 'status', "aria-live": 'polite', "aria-busy": true },
            react_1.default.createElement("div", { className: WebUpdateScreen_less_1.default['title'] }, t('CAROLINE_UPDATE_APPLYING', { defaultValue: 'A actualizar a Caroline…' })),
            react_1.default.createElement("div", { className: WebUpdateScreen_less_1.default['progress'], "aria-hidden": true },
                react_1.default.createElement("div", { className: WebUpdateScreen_less_1.default['progress-value'] }))));
    }
    return (react_1.default.createElement(components_1.UpdateBanner, { className: WebUpdateScreen_less_1.default['web-update-banner'], visible: promptVisible, label: t('CAROLINE_UPDATE_AVAILABLE', { defaultValue: 'Está disponível uma nova versão da Caroline.' }), actionLabel: state.status === 'failed' ? t('TRY_AGAIN') : t('RELOAD_UI'), closeLabel: t('BUTTON_CLOSE'), onAction: applyUpdate, onClose: dismissUpdate }));
};
exports.default = WebUpdateScreen;
